import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";
function Newsletter_46() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter July 2026
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            New Zealand Proposes IFRS S2 to Strengthen Climate Disclosure
            Framework.
          </title>
          <meta
            name="description"
            content="The Science Based Targets initiative (SBTi) has released a draft revision of its Corporate Net-Zero Standard, marking one of the most significant updates to the global framework used by businesses to align climate strategies with the Paris Agreement’s 1.5°C pathway"
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          New Zealand Proposes IFRS S2 to Strengthen Climate Disclosure
          Framework.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/July_2026_1.webp")}
            alt="New Zealand Proposes IFRS S2 to Strengthen Climate Disclosure Framework."
            loading="lazy"
          />
        </figure>
        <p>
          New Zealand’s External Reporting Board has opened consultation on a
          draft climate reporting roadmap that would introduce NZ IFRS S2
          Climate-related Disclosures, aligning the country’s framework with the
          International Sustainability Standards Board’s IFRS S2 while
          considering local legislative and market requirements for regulated
          climate reporting entities.
        </p>
        <p>
          The proposal would allow early adoption for reporting periods
          beginning in the coming years, followed by mandatory application later
          under the proposed timeline. During the transition, climate reporting
          entities could continue using the existing Aotearoa New Zealand
          Climate Standards. The phased approach reflects New Zealand’s
          leadership in introducing mandatory climate-related disclosures in
          recent years for large listed issuers, banks, insurers, and investment
          managers under its established reporting framework.
        </p>
        <p>
          IFRS S2 became effective internationally in recent years and focuses
          on climate-related risks and opportunities that may affect cash flows,
          access to finance, or the cost of capital. Adoption would strengthen
          comparability with global reporting practices and support alignment
          with Australia’s AASB S2 framework while maintaining scope for New
          Zealand-specific modifications that support consistent domestic
          sustainability reporting over time.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Adopting IFRS S2 would enhance the consistency, comparability, and
            credibility of climate-related disclosures across New Zealand’s
            financial markets. Alignment with internationally recognised
            reporting standards can improve transparency for investors, support
            cross-border capital flows, reduce reporting complexity for
            multinational organisations, and help businesses meet growing
            stakeholder expectations while maintaining compatibility with
            evolving global sustainability disclosure frameworks.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          UK Reinforces Net Zero Roadmap with Proposed 87% Emissions Cut by
          2040.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/July_2026_2.webp")}
              alt="UK Reinforces Net Zero Roadmap with Proposed 87% Emissions Cut by 2040."
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          The UK has proposed a legally binding target to reduce greenhouse gas
          emissions by 87% from 1990 levels by 2040 under its Seventh Carbon
          Budget for 2038-2042. The proposal strengthens the country's pathway
          to its statutory net zero objective by 2050 and aligns with advice
          from the independent Climate Change Committee.
        </p>
        <p>
          Government analysis indicates national greenhouse gas emissions have
          already fallen about 54% since 1990, while the pace of reductions has
          more than doubled since carbon budgets were introduced in 2008.
          Renewable electricity expansion, coal phaseout, and improved energy
          efficiency have supported sustained progress alongside legally
          established 2030 and 2035 emissions targets supporting business
          investment, low-carbon transport, industrial decarbonisation efforts.
        </p>
        <p>
          For businesses, the proposed budget provides greater policy certainty
          for long-term investment, climate risk management, transition
          planning, and sustainability disclosures. The framework is expected to
          encourage continued deployment of clean technologies, electrification,
          resilient infrastructure, and supply chain decarbonisation while
          supporting alignment with evolving ESG expectations and the United
          Kingdom's broader climate commitments across key economic sectors over
          coming decades ahead.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The significance of the UK's proposed target extends beyond
            emissions reduction. It signals increasing convergence between
            climate policy, sustainable finance, corporate reporting, and
            industrial competitiveness. As regulatory frameworks mature,
            businesses will need to demonstrate credible transition progress
            supported by measurable actions, robust governance, and transparent
            performance reporting.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          European Banking Authority (EBA) Expands Proportionate ESG Disclosure
          Framework for Banks.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/July_2026_3.webp")}
            alt="European Banking Authority (EBA) Expands Proportionate ESG Disclosure Framework for Banks."
            loading="lazy"
          />
        </figure>
        <p>
          The European Banking Authority has updated its Pillar 3 ESG disclosure
          framework to simplify reporting for banks while extending
          proportionate requirements to smaller institutions for the first time.
          The measures align with Capital Requirements Regulation III and
          support consistent transparency on environmental, social, and
          governance risks across the European banking sector, reducing
          duplication while maintaining regulatory oversight.
        </p>
        <p>
          Large listed institutions will continue detailed disclosures, but
          required datapoints have been reduced by approximately 37% under the
          revised framework. Smaller and non-complex institutions will follow
          streamlined templates reflecting their scale and risk profile. The
          approach also improves alignment with European Sustainability
          Reporting Standards to encourage greater consistency across public
          reporting and supervisory reporting obligations over time.
        </p>
        <p>
          The revised framework also incorporates updated guidance for
          disclosures covering transition risks, physical climate risks, and
          exposures associated with carbon-intensive sectors where applicable.
          Standardized reporting templates and common definitions are designed
          to improve data consistency across supervisory assessments and
          published sustainability information within the European Union while
          supporting comparable risk monitoring across diverse banking business
          models efficiently.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The revised disclosure framework reinforces the importance of
            embedding climate-related risks within prudential risk management
            rather than treating ESG reporting as a standalone exercise.
            Institutions can benefit from integrating transition and physical
            risk assessments into credit, capital, and portfolio management
            processes supported by reliable, auditable data.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Italy Expands Renewable Electricity Investment Through €23 Billion
          Support Programme.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/July_2026_4.webp")}
            alt="Italy Expands Renewable Electricity Investment Through €23 Billion Support Programme."
            loading="lazy"
          />
        </figure>
        <p>
          Italy will introduce a €23 billion renewable electricity support
          programme following regulatory approval, reinforcing national efforts
          to expand clean power generation. The scheme covers onshore wind,
          solar, hydropower, and sewage gas projects, with planned additions
          exceeding 37 gigawatts of renewable capacity, representing
          approximately 48% of Italy’s current installed renewable electricity
          base. Support will be provided through two way contracts for
          difference lasting twenty years, offering predictable investment
          conditions while balancing market price movements.
        </p>
        <p>
          Funding will primarily be allocated through competitive bidding, while
          installations below one megawatt may receive direct support under
          prices established by Italy’s energy regulator. Larger solar and wind
          projects must satisfy additional regulatory requirements before
          participating in dedicated auctions. The programme’s estimated budget
          reflects current electricity market assumptions, meaning actual public
          expenditure could vary with future wholesale power prices. Separate
          procurement pathways aim to accommodate smaller developers alongside
          utility scale investments across multiple regions.
        </p>
        <p>
          The programme aligns with Italy's National Energy and Climate Plan,
          supporting faster renewable deployment through technology neutral
          auctions and long term investment planning.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Renewable support frameworks are evolving from subsidy-driven models
            to market-based instruments that balance investor confidence with
            price discipline. This approach reflects a broader shift towards
            integrating clean energy into competitive electricity markets while
            maintaining long-term policy certainty for infrastructure
            development and capital deployment.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          EU Expands Carbon Border Adjustment Framework to Selected Downstream
          Products.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/July_2026_5.webp")}
            alt="EU Expands Carbon Border Adjustment Framework to Selected Downstream Products."
            loading="lazy"
          />
        </figure>

        <p>
          European Union member states have agreed a negotiating position to
          expand the Carbon Border Adjustment Mechanism to selected downstream
          products, broadening carbon pricing beyond primary materials. The
          proposal supports climate objectives by addressing carbon leakage
          risks across manufacturing value chains while maintaining alignment
          with the EU Emissions Trading System. Negotiations with the European
          Parliament will follow next.
        </p>
        <p>
          Current proposals cover approximately 180 steel and aluminium
          intensive product categories, including machinery, vehicle components,
          household appliances, and construction equipment. CBAM entered into
          force in 2026 after adoption in 2023, complementing the EU emissions
          trading framework through carbon pricing for eligible imports and
          encouraging lower emissions across international supply chains while
          supporting transparent trade reporting requirements globally.
        </p>
        <p>
          The Council's position also introduces stronger anti-circumvention
          measures and annual reviews to assess further product coverage. These
          developments reflect continuing integration of climate policy with
          international trade governance, providing businesses with greater
          regulatory visibility as legislative discussions continue across
          European institutions during 2026, supporting consistent compliance
          planning and investment decisions across affected sectors
          internationally ahead progressively.
        </p>
        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The expansion signals a gradual shift from product-level carbon
            accountability toward value-chain transparency. As regulatory
            boundaries evolve, organizations may increasingly integrate
            emissions data, procurement strategies, and supplier engagement into
            long-term competitiveness, reinforcing climate governance through
            measurable, internationally aligned compliance frameworks and
            informed capital allocation, operational resilience, strategic
            adaptation, over time.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_46;
